"use client";

import Link from "next/link";
import { useState } from "react";

export default function Header() {
  const [burgerMenu, setBurgerMenu] = useState(false);

  return (
    <>
      <header className="absolute top-0 left-0 right-0 z-50">
        <div className="max-w-[1872px] mx-auto px-6">
          <div className="max-w-[1198px] mx-auto px-6 pt-10 pb-6">
            <nav className="flex items-center justify-between w-full gap-4">
            <Link href="/" className="flex items-center shrink-0">
              <span className="relative inline-flex items-baseline h-[40px]">
                <span className="text-white text-[26px] font-bold tracking-[-1px] mt-auto">paw</span>
                <img
                  src="/Images/landing/logo-toes.svg"
                  alt=""
                  className="absolute w-[35px] h-[30px] left-[22px] top-0"
                />
                <img
                  src="/Images/landing/logo-white.svg"
                  alt=""
                  className="absolute w-[33px] h-[30px] left-[19px] top-[10px]"
                />
              </span>
              <span className="text-white text-[26px] font-medium tracking-[-1px] mt-auto">
                payments
              </span>
            </Link>

            <div className="hidden lg:flex items-center gap-9 min-w-0">
              <div className="flex items-center gap-9">
                <Link
                  href="/"
                  className="text-white text-sm hover:opacity-80 transition-opacity"
                >
                  Home
                </Link>
                <Link
                  href="/#faq"
                  className="text-white/40 text-sm hover:text-white transition-colors"
                >
                  FAQ
                </Link>
                <Link
                  href="/#partners"
                  className="text-white/40 text-sm hover:text-white transition-colors"
                >
                  Partners
                </Link>
                <a
                  href="https://docs.pawpayments.com"
                  target="_blank"
                  rel="noopener"
                  className="text-white/40 text-sm hover:text-white transition-colors"
                >
                  Documentation
                </a>
                <Link
                  href="/blog"
                  className="text-white/40 text-sm hover:text-white transition-colors"
                >
                  Blog
                </Link>
                <a
                  href="https://status.pawpayments.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/40 text-sm hover:text-white transition-colors"
                >
                  Status
                </a>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <a
                  href="/auth"
                  className="text-white/80 text-sm font-medium px-3 py-3 hover:text-white transition-colors"
                >
                  Sign in
                </a>
                <a
                  href="/auth"
                  className="bg-[#0079ec] text-white text-sm font-medium px-4 py-3 rounded-[10px] hover:bg-[#0069d0] transition-colors"
                >
                  Get started
                </a>
              </div>
            </div>

            <button
              type="button"
              className={`lg:hidden flex flex-col gap-[5px] w-[24px] ${burgerMenu ? "burger-active" : ""}`}
              onClick={() => setBurgerMenu(!burgerMenu)}
            >
              <span
                className={`block w-full h-[2px] bg-white rounded transition-all ${burgerMenu ? "rotate-45 translate-y-[7px]" : ""}`}
              />
              <span
                className={`block w-full h-[2px] bg-white rounded transition-all ${burgerMenu ? "opacity-0" : ""}`}
              />
              <span
                className={`block w-full h-[2px] bg-white rounded transition-all ${burgerMenu ? "-rotate-45 -translate-y-[7px]" : ""}`}
              />
            </button>
            </nav>
          </div>
        </div>
      </header>

      {burgerMenu && (
        <div className="fixed inset-0 z-40 bg-[#00060b] pt-24 px-6 lg:hidden">
          <div className="flex flex-col gap-6">
            <a
              href="/auth"
              className="bg-[#0079ec] text-white text-base font-medium px-6 py-4 rounded-xl text-center"
            >
              Get started
            </a>
            <a
              href="/auth"
              className="text-white/80 text-base font-medium px-6 py-3 rounded-xl text-center border border-white/10"
            >
              Sign in
            </a>
            <ul className="flex flex-col gap-4">
              <li>
                <Link
                  href="/"
                  className="text-white text-lg"
                  onClick={() => setBurgerMenu(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  href="/#faq"
                  className="text-white/60 text-lg hover:text-white transition-colors"
                  onClick={() => setBurgerMenu(false)}
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  href="/#partners"
                  className="text-white/60 text-lg hover:text-white transition-colors"
                  onClick={() => setBurgerMenu(false)}
                >
                  Partners
                </Link>
              </li>
              <li>
                <a
                  href="https://docs.pawpayments.com"
                  target="_blank"
                  rel="noopener"
                  className="text-white/60 text-lg hover:text-white transition-colors"
                >
                  Documentation
                </a>
              </li>
              <li>
                <Link
                  href="/blog"
                  className="text-white/60 text-lg hover:text-white transition-colors"
                  onClick={() => setBurgerMenu(false)}
                >
                  Blog
                </Link>
              </li>
              <li>
                <a
                  href="https://status.pawpayments.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/60 text-lg hover:text-white transition-colors"
                >
                  Status
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
